import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const LoginPage = () => {
  const link = "https://api.dashboard.bhumu.com";
  // const link = "http://localhost:7051";
  // const link = "http://192.168.1.4:7051";

  // check user start ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const verifyUser = async () => {
    try {
      const response = await fetch(`${link}/admin/verify`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json",
        },
      });

      if (response.ok) {
        const respData = await response.json();
        const role = respData.user.role;

        if (role === "admin") {
          navigate("/admin");
        } else if (role === "user") {
          navigate("/dashboard");
        }
      } else {
        navigate("/");
      }
    } catch (error) {
      navigate("/");
    }
  };

  useEffect(() => {
    verifyUser();
  }, []);

  // check user end ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const [showForgot, setShowforgot] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [passwordConfirmed, setPasswordConfirmed] = useState(false);
  const [updatePassword, setUpdatePassword] = useState(false);

  const [data, setData] = useState({
    email: "",
    password: "",
    otp: "",
  });

  const handleInput = (e) => {
    setError(false);
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckLoginPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${link}/admin/login-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setPasswordConfirmed(true);
      } else {
        const error = await response.json();
        setError(error.message);

        console.log(error);
      }
    } catch (error) {
      console.log(error);
      setError("Server Error");
    }

    setLoading(false);
  };

  const navigate = useNavigate();

  const handleLoginOtpVerification = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${link}/admin/verify-login-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        credentials: "include",
      });

      if (response.ok) {
        const value = await response.json();
        verifyUser();
      } else {
        const error = await response.json();
        setError(error.message);
        console.log(error);
      }
    } catch (error) {
      console.log(error);
      setError("Server Error");
    }

    setLoading(false);
  };

  const handleCheckForgotMail = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${link}/forgot-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setUpdatePassword(true);
      } else {
        const respData = await response.json();
        setError(respData.message);
      }
    } catch (error) {
      alert("Server Error");
      console.log(error);
    }

    setLoading(false);
  };

  const handleForgotOtpVerification = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${link}/verify-forgot-otp`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        credentials: "include",
      });

      if (response.ok) {
        verifyUser();
      } else {
        const respData = await response.json();
        setError(respData.message);
      }
    } catch (error) {
      alert("Server Error");
      console.log(error);
    }

    setLoading(false);
  };

  return (
    <div>
      <div className="login-dashbord-bg">
        <div className="login-dashbord-main">
          <div className="login-dashbord-main-content">
            <div className="login-dashbord-main-login-left-col">
              <div className="login-dashbord-login-left-col-heading">
                Welcome to <br />
                BHUMU Group <br />
                admin panel
              </div>

              <div className="login-dashbord-login-left-col-description">
                join our community your productive journey starts here.
              </div>
            </div>

            <div className="login-dashbord-form-container">
              {showForgot ? (
                <div className="login-dash-bord-forget  login-dash-bord-main-form ">
                  <div className="login-dash-bord-main-form-heading">
                    Update Password
                  </div>
                  {updatePassword ? (
                    <form onSubmit={handleForgotOtpVerification}>
                      <div>
                        <input
                          required
                          value={data.email}
                          type="text"
                          placeholder="Enter your Email Id"
                          disabled
                        ></input>
                      </div>
                      <div>
                        <input
                          required
                          value={data.otp}
                          type="text"
                          placeholder="Enter OTP"
                          onChange={handleInput}
                          name="otp"
                        ></input>
                      </div>
                      <div>
                        <input
                          name="password"
                          required
                          value={data.password}
                          type="password"
                          placeholder="Enter Password"
                          onChange={handleInput}
                        ></input>
                      </div>

                      {error ? (
                        <div className="login-dash-bord-main-form-error">
                          {error}
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="login-button-admin-dashbord">
                        <button>Change Password</button>
                      </div>
                    </form>
                  ) : (
                    <form onSubmit={handleCheckForgotMail}>
                      <div>
                        <input
                          required
                          value={data.email}
                          type="email"
                          placeholder="Enter your Email Id"
                          name="email"
                          onChange={handleInput}
                        ></input>
                      </div>

                      {error ? (
                        <div className="login-dash-bord-main-form-error">
                          {error}
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="login-button-admin-dashbord">
                        {loading ? (
                          <button
                            className="login-button-admin-dashbord-disable"
                            disabled
                          >
                            Request OTP
                          </button>
                        ) : (
                          <button>Request OTP</button>
                        )}
                      </div>
                    </form>
                  )}
                  <div className="login-dashbord-back-to-login-main-btn">
                    <div
                      className="login-dashbord-back-to-login"
                      onClick={() => {
                        setShowforgot(false);
                        setPasswordConfirmed(null);
                        setUpdatePassword(null);
                        setData({
                          email: "",
                          password: "",
                          otp: "",
                        });
                      }}
                    >
                      {" "}
                      <i class="fa-solid fa-arrow-left"></i> Back to Login
                    </div>
                  </div>
                </div>
              ) : (
                <div className="login-dash-bord-main-form">
                  <div className="login-dash-bord-main-form-heading">
                    Login To Your Account
                  </div>
                  {passwordConfirmed ? (
                    <form onSubmit={handleLoginOtpVerification}>
                      <div className="first-input">
                        <input
                          required
                          value={data.email}
                          type="email"
                          disabled
                          placeholder="Enter Your Email Addres"
                        />
                      </div>

                      <div>
                        <input
                          name="otp"
                          onChange={handleInput}
                          required
                          value={data.otp}
                          type="text"
                          placeholder="Enter OTP"
                        />
                      </div>

                      {error ? (
                        <div className="login-dash-bord-main-form-error">
                          {error}
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="login-button-admin-dashbord">
                        {loading ? (
                          <button
                            className="login-button-admin-dashbord-disable"
                            disabled
                          >
                            Verify
                          </button>
                        ) : (
                          <button>Verify</button>
                        )}
                      </div>
                    </form>
                  ) : (
                    <form onSubmit={handleCheckLoginPassword}>
                      <div className="first-input">
                        <input
                          required
                          value={data.email}
                          name="email"
                          onChange={handleInput}
                          placeholder="Enter Your Email Addresss"
                        />
                      </div>

                      <div>
                        <input
                          name="password"
                          onChange={handleInput}
                          required
                          value={data.password}
                          type="password"
                          placeholder="Enter Your Password"
                        />
                      </div>

                      {error ? (
                        <div className="login-dash-bord-main-form-error">
                          {error}
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="login-button-admin-dashbord">
                        {loading ? (
                          <button
                            className="login-button-admin-dashbord-disable"
                            disabled
                          >
                            Login
                          </button>
                        ) : (
                          <button>Login</button>
                        )}
                      </div>
                    </form>
                  )}

                  <div className="login-dash-bord-forgot-row">
                    <div></div>
                    <div>
                      <Link
                        to=""
                        onClick={() => {
                          setShowforgot(true);
                          setPasswordConfirmed(null);
                          setUpdatePassword(null);
                          setData({ email: "", password: "", otp: "" });
                        }}
                      >
                        {" "}
                        Forgot password?{" "}
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
